import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatDate } from '@/utils/formatDate';
import FlipUnitContainer from './Count/FlipUnitCountainer';

// 预约公示炸弹组件
export default {
  components: {
    FlipUnitContainer: FlipUnitContainer
  },
  name: 'ReminderPublic',
  data: function data() {
    return {
      showStatus: true,
      onSaleTimeLabel: null,
      // 开售时间文本
      bgClassName: 'sss',
      // 背景图className
      appointSum: 0,
      // 缺货登记总人数
      appointRenderData: null,
      // 预约人数renderData
      max: 9999999
    };
  },
  props: {
    ifShow: {
      type: Boolean,
      default: true
    },
    number: {
      type: Number
    },
    // 开售前讯息
    beforeSaleStatus: {
      type: Object
    },
    // 浮层上的文本
    floatLabel: {
      type: String
    }
  },
  created: function created() {
    // this.test()
  },
  mounted: function mounted() {
    this.getOnSaleTime();
    this.getClass();
    this.appointRenderData = this.formatAppoint(this.number);
    this.appointSum = this.number;
  },
  watch: {
    number: function number(val) {
      if (this.appointSum !== val) {
        this.appointRenderData = this.formatAppoint(val);
        this.appointSum = val;
      }
    }
  },
  methods: {
    getSumString: function getSumString(sum) {
      if (sum == null) return;
      if (sum >= this.max) {
        sum = this.max;
      }
      var sumString = sum + '';
      if (sumString.length < 4) {
        sumString = (Array(4).join(0) + sum).slice(-4) + '';
      }
      return sumString;
    },
    formatAppoint: function formatAppoint(sum) {
      var _this = this;
      if (sum == null) return;
      var sumString = this.getSumString(sum);
      var sumList = sumString.split('');
      var appointRenderData = sumList.map(function (item, index) {
        var previousNum = 0;
        var previousShuffle = true;
        if (_this.appointRenderData && _this.appointRenderData[index]) {
          previousNum = _this.appointRenderData[index].num;
          previousShuffle = _this.appointRenderData[index].shuffle;
        }
        return {
          num: Number(item),
          // eslint-disable-next-line eqeqeq
          shuffle: previousNum == item ? previousShuffle : !previousShuffle,
          previous: previousNum
        };
      });
      return appointRenderData;
    },
    // 当设置了开售时间时 显示开售时间
    getOnSaleTime: function getOnSaleTime() {
      var onSaleTime = this.beforeSaleStatus.onSaleTime;
      if (onSaleTime) {
        this.onSaleTimeLabel = formatDate(new Date(onSaleTime), 'M月d日 hh:mm');
      }
    },
    // class
    getClass: function getClass() {
      var className;
      if (!this.onSaleTimeLabel && !this.floatLabel) {
        className = 'bomb-bg-nolabel';
      } else if (this.onSaleTimeLabel && this.floatLabel) {
        className = 'bomb-bg-alllabel';
      } else {
        className = 'bomb-bg-onelabel';
      }
      this.bgClassName = className;
    },
    hide: function hide() {
      var bomb = document.getElementById('bomb-component');
      bomb.animate([{
        top: 0
      }, {
        top: '150%'
      }], {
        fill: 'forwards',
        duration: 800
      });
    },
    show: function show() {
      var bomb = document.getElementById('bomb-component');
      bomb.animate([{
        top: '150%'
      }, {
        top: 0
      }], {
        fill: 'forwards',
        duration: 800
      });
    }
  }
};